// Copyright (c) Docugami, Inc. All rights reserved.

import { TokenRange } from "networking/api";
import { inRangeInclusive } from "utils/MathUtils";
import { TokenRangeUtils } from "utils/TokenRangeUtils";
import { Point } from "./Types";

export interface Page {
    id: string;
    pageIndex: number;
    number: number;
    width: number;
    height: number;
    sourceWidth: number;
    sourceHeight: number;
    position: Point;
    tokenRanges: TokenRange[];
    scaleFactor: number;
}

export function getTokenRangesForPages(pages: Page[]): TokenRange[] {
    return pages.flatMap(page => page.tokenRanges);
}

export interface PageAndRange {
    page: Page,
    tokenRange: TokenRange
}

// Gets the page for a token, and the target range that the token is within
export function getPageForToken(pages: Page[], token: number): PageAndRange | null {
    for (const page of pages) {
        for (const tokenRange of page.tokenRanges) {
            if (inRangeInclusive(token, tokenRange.fromTok, tokenRange.toTok)) {
                return {
                    page: page,
                    tokenRange: tokenRange
                }
            }
        }
    }

    return null;
}

export function getPageForPos(pages: Page[], yPos: number): Page | null {
    return pages.find(x => yPos >= x.position.y && yPos <= x.position.y + x.height) ?? null;
}

export function rangeOverlapsPages(tokenRange: TokenRange, pages: Page[]) {
    const pageRanges = getTokenRangesForPages(pages);
    return pageRanges.find(pageRange => TokenRangeUtils.rangesOverlap(tokenRange, pageRange));
}